import { Home } from '__legacy__/routes/config/Home';
import { useTranslator } from '@Localization';
import { useConfiguration } from 'common/hooks/useConfiguration';
import { S_Tab } from 'design/tabs/tab/S_Tab';
import { S_TabsContainer } from 'design/tabs/tabsContainer/S_TabsContainer';
import { useInjection } from 'inversify-react';
import { ICurrentWorkspaceStore } from 'modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { ReactElement, useContext, useEffect } from 'react';
import { AdminContext } from '../AdminContext';

export const AdminTabs = (): ReactElement => {
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const adminContext = useContext(AdminContext);
  const config = useConfiguration();

  useEffect(() => {
    if (adminContext.search) {
      adminContext.setSearch('');
    }
  }, []);

  const { t } = useTranslator();

  const path = window.location.pathname;
  let filterIndex = ['users', 'workspaces'].findIndex((s) => path.includes(s));
  if (filterIndex < 0) {
    filterIndex = 0;
  }

  const workspaceId = currentWorkspaceStore.currentWorkspace.id;

  return (
    <S_TabsContainer>
      <S_Tab
        text={t('users')}
        link={Home.Admin.Users.withParams({ workspaceId })}
        state={filterIndex === 0 ? 'active' : 'passive'}
      />
      {!config.appConfig.runLocally && (
        <S_Tab
          text={t('workspaces_header')}
          link={Home.Admin.Workspaces.withParams({ workspaceId })}
          state={filterIndex === 1 ? 'active' : 'passive'}
        />
      )}
    </S_TabsContainer>
  );
};
